import React, { Dispatch, SetStateAction, ReactNode, useState } from 'react';

type HCaptchaContextProps =
  | {
      hCaptchaToken: string;
      setHCaptchaToken: Dispatch<SetStateAction<string>>;
      executeHCaptcha: boolean;
      setExecuteHCaptcha: Dispatch<SetStateAction<boolean>>;
    }
  | undefined;

export const HCaptchaContext = React.createContext<HCaptchaContextProps>(undefined);

const HCaptchaProvider: React.FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [hCaptchaToken, setHCaptchaToken] = useState('');
  const [executeHCaptcha, setExecuteHCaptcha] = useState(false);

  return (
    <HCaptchaContext.Provider
      value={{
        hCaptchaToken,
        setHCaptchaToken,
        executeHCaptcha,
        setExecuteHCaptcha,
      }}
    >
      {children}
    </HCaptchaContext.Provider>
  );
};

export function useHCaptchaContext() {
  const context = React.useContext(HCaptchaContext);
  if (!context) {
    throw new Error('You must use the HCaptchaProvider in order to consume this context.');
  }
  return context;
}

export default HCaptchaProvider;
